import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M972.668586,550.592337 C1047.03925,550.592337 1186.48425,447.198973 1333.29829,462.277172 C1394.74479,464.88468 1567.18043,487.558663 1677.94284,652.738632 C1669.09998,658.633868 1472.06307,775.518252 1474.44384,1018.92346 C1476.93797,1309.83067 1724.4245,1406.42184 1727.25875,1407.89565 C1724.99135,1414.4711 1687.69265,1545.75347 1596.76998,1681.34389 C1518.20462,1798.45501 1436.80502,1914.99928 1308.47028,1917.38005 C1182.28956,1919.87419 1141.70313,1841.0821 997.383228,1841.0821 C853.176694,1841.0821 808.168837,1914.99928 688.676945,1919.87419 C564.763626,1924.63573 470.439855,1793.35336 391.307653,1676.69572 C229.415412,1437.8253 105.728833,1002.03135 271.815761,707.836411 C354.235691,561.702589 501.616582,469.192737 661.694904,466.811969 C783.340825,464.54457 898.29792,550.592337 972.668586,550.592337 Z M1367.75141,-5.68434189e-14 C1380.78895,110.535669 1333.06021,221.524817 1262.6575,301.450608 C1191.91467,381.26303 1076.16398,443.389744 962.680696,435.00037 C947.375757,326.50536 1004.62757,213.815663 1069.92864,142.846095 C1142.93886,63.0336736 1266.17196,3.85457717 1367.75141,-5.68434189e-14 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAppleSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAppleSolid, _Component);

  var _super = _createSuper(IconAppleSolid);

  function IconAppleSolid() {
    _classCallCheck(this, IconAppleSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAppleSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconApple",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAppleSolid.displayName = "IconAppleSolid";
  return IconAppleSolid;
}(Component);

IconAppleSolid.glyphName = 'apple';
IconAppleSolid.variant = 'Solid';
IconAppleSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAppleSolid;
export { IconAppleSolid };